import { useAlert } from "../../../lib/hooks/alert";
import Alert, { AlertType } from "../../core/alert/alert";

interface ExternalLayoutProps {
  children: React.ReactNode;
}

const ExternalLayout = ({ children }: ExternalLayoutProps) => {
  const { alert } = useAlert();

  return (
    <>
      <main>{children}</main>
      <Alert type={alert?.type} alert={alert as AlertType} />
    </>
  );
};

export default ExternalLayout; 